import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-46d5a114")

_pushScopeId("data-v-46d5a114")
const _hoisted_1 = { class: "circle-container" }
const _hoisted_2 = { class: "circle-wrapper" }
const _hoisted_3 = {
  class: "circle-progress",
  viewBox: "0 0 100 100"
}
const _hoisted_4 = { class: "circle-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          class: "circle-bg",
          style: { borderColor: _ctx.currentGradient.backgroundColor }
        }, null, 4),
        (_openBlock(), _createBlock("svg", _hoisted_3, [
          _createVNode("defs", null, [
            _createVNode("linearGradient", {
              id: _ctx.circleId,
              x1: "0%",
              y1: "0%",
              x2: "0%",
              y2: "100%"
            }, [
              _createVNode("stop", {
                offset: "0%",
                "stop-color": _ctx.currentGradient.color1
              }, null, 8, ["stop-color"]),
              _createVNode("stop", {
                offset: "100%",
                "stop-color": _ctx.currentGradient.color2
              }, null, 8, ["stop-color"])
            ], 8, ["id"])
          ]),
          _createVNode("circle", {
            cx: "50",
            cy: "50",
            r: "45",
            "stroke-width": _ctx.strokeWidthRender,
            stroke: _ctx.currentGradient.backgroundColor,
            fill: "none"
          }, null, 8, ["stroke-width", "stroke"]),
          _createVNode("circle", {
            cx: "50",
            cy: "50",
            r: "45",
            "stroke-width": _ctx.strokeWidthRender,
            stroke: `url(#${_ctx.circleId})`,
            fill: "none",
            "stroke-linecap": "butt",
            "stroke-dasharray": _ctx.circumference,
            "stroke-dashoffset": _ctx.dashOffset,
            transform: "rotate(-90 50 50)"
          }, null, 8, ["stroke-width", "stroke", "stroke-dasharray", "stroke-dashoffset"])
        ])),
        _createVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ])
  ]))
})